import { Button, Tooltip } from '@dixa/lib-shared-habla';
import { useModal } from 'lib-knowledge-modal';

import { GoLiveModal } from '../modals/goLiveModal';
import { VersionNameModal } from '../modals/versionNameModal';

import { AiSettingsVersionSummary } from './versionSwitcher';

/**
 * On a saved version, going live with it. On the draft, saving it as a
 * version — which needs a draft with changes, saved.
 */
export function VersionActions({
  viewedVersion,
  readOnly,
  hasDraft,
  hasUnsavedChanges,
}: {
  /** The saved version on screen, once loaded. */
  viewedVersion: AiSettingsVersionSummary | undefined;
  readOnly: boolean;
  /** Whether the draft holds changes no version has. */
  hasDraft: boolean;
  hasUnsavedChanges: boolean;
}): JSX.Element {
  const { showModal } = useModal();

  if (readOnly) {
    return (
      <Button
        variant="primary"
        disabled={!viewedVersion || viewedVersion.isActive}
        onClick={() =>
          viewedVersion &&
          showModal(GoLiveModal, {
            versionId: viewedVersion.id,
            name: viewedVersion.name,
          })
        }
      >
        Go live
      </Button>
    );
  }

  const disabledReason = hasUnsavedChanges
    ? 'Save your changes to the draft first'
    : !hasDraft
      ? 'Change and save the draft in order to create a version'
      : undefined;

  return (
    <>
      <Tooltip content={disabledReason} disabled={!disabledReason}>
        <Button
          variant="secondary"
          disabled={!!disabledReason}
          onClick={() => showModal(VersionNameModal, { mode: 'create' })}
        >
          Create version
        </Button>
      </Tooltip>
      <Tooltip content={disabledReason} disabled={!disabledReason}>
        <Button
          variant="secondary"
          disabled={!!disabledReason}
          onClick={() => showModal(VersionNameModal, { mode: 'goLive' })}
        >
          Create and go live
        </Button>
      </Tooltip>
    </>
  );
}
